import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Cookies } from "react-cookie";
import useWebSocket from "react-use-websocket";
import tradeColumns from "../../../../columns/trades.jsx";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";

const OpenTrades = () => {
  const { userDetails } = useSelector((state) => state.user);
  const [liveData, setLiveData] = useState([]);
  const cookies = new Cookies();
  const token = cookies.get("token");

  const { sendJsonMessage, lastJsonMessage } = useWebSocket(
    `${process.env.REACT_APP_SOCKET_URL}?authorization=Bearer ${token}`,
    { shouldReconnect: () => true, share: true }
  );

  const columns = tradeColumns.filter((column) => column.dataIndex !== "close");

  useEffect(() => {
    sendJsonMessage({
      action: "subscribe",
      eventType: "FirstLevelOpenTrade",
      userId: userDetails?._id,
    });

    return () => {
      sendJsonMessage({
        action: "unsubscribe",
        eventType: "FirstLevelOpenTrade",
        userId: userDetails?._id,
      });
    };
  }, []);

  useEffect(() => {
    if (lastJsonMessage?.eventType === "FirstLevelOpenTrade") {
      setLiveData(lastJsonMessage?.data?.Data || []);
    }
  }, [lastJsonMessage]);

  return <TableWithSkeleton columns={columns} data={liveData} />;
};

export default OpenTrades;
